import { isHubteamDomain } from '../utils/isHubteamDomain';
let _defaultClient;
export const getDefaultHttpClient = () => {
  if (_defaultClient) {
    return _defaultClient;
  }
  if (isHubteamDomain()) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _defaultClient = require('hub-http-janus/clients/adaptiveIdpAuthApiClient').default;
  } else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _defaultClient = require('hub-http/clients/apiClient').default;
  }
  return _defaultClient;
};
export const __testOnly_resetDefaultHttpClient = () => {
  _defaultClient = undefined;
};
export const __testOnly_setDefaultHttpClient = client => {
  _defaultClient = client;
};